import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['cell']
  static values = { url: String }

  connect() {
    const clientIds = this.cellTargets.map((cell) => cell.dataset.clientId)
    if (clientIds.length === 0) return

    const params = new URLSearchParams()
    for (const id of clientIds) {
      params.append('client_ids[]', id)
    }

    fetch(`${this.urlValue}?${params}`, {
      headers: { Accept: 'application/json' },
    })
      .then((r) => r.json())
      .then((results) => {
        for (const { client_id, has_active_action_item } of results) {
          const cell = this.cellTargets.find((c) => c.dataset.clientId === client_id)
          if (!cell) continue

          if (has_active_action_item) {
            cell.innerHTML = `
              <span class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-2xl border border-brick bg-peach-25 text-charcoal">
                <span class="w-2 h-2 rounded-full bg-brick-light shrink-0"></span>
                Needs school action
              </span>`
          }
        }
      })
      .catch(() => {
        // leave em dashes in place on error
      })
  }
}
